import {isAxiosError} from 'axios';

/** Сообщения для ошибок команд комментария без вывода технического ответа сервера. */
export const taskCommentError = (
  error: unknown,
  operation: 'edit' | 'delete',
) => {
  const status = isAxiosError(error) ? error.response?.status : undefined;
  if (status === 401) return 'Сессия завершена. Войдите в аккаунт снова.';
  if (status === 403)
    return 'Нет прав на действие или выбранный участник недоступен для упоминания.';
  if (status === 404) return 'Комментарий удалён или задача больше недоступна.';
  if (status === 413)
    return 'Достигнут лимит истории задачи. Изменение не сохранено.';
  if (status === 400 || status === 422)
    return 'Проверьте текст (1–5000 символов) и упоминания (не более двух участников).';
  return operation === 'edit'
    ? 'Не удалось подтвердить сохранение. Текст оставлен в редакторе; проверьте соединение и повторите.'
    : 'Не удалось подтвердить удаление. Обновите задачу или повторите попытку.';
};
